import React, { ChangeEvent, SetStateAction, Dispatch } from 'react';
import { ChangePlanRequest } from '../types';
import { RadioFieldBox } from '@/components/RadioField';
import { DateFieldBox } from '@/components/DateField';

type ChangePlanFormProps = {
  label: string;
  plan?: string;
  changePlanRequest: ChangePlanRequest;
  status?: string;
  setChangePlanRequest: Dispatch<SetStateAction<ChangePlanRequest>>;
}

export const ChangePlanForm: React.FC<ChangePlanFormProps> = ({
  label,
  plan,
  changePlanRequest,
  setChangePlanRequest,
  status
}) => {
  const displayPlan = (plan: string): string => {
    if(plan === 'both') return `両眼プラン`
    if(plan === 'right') return `片眼プラン(右眼)`
    if(plan === 'left') return `片眼プラン(左眼)`
    return '';
  }

  const planOptions = [
    {
      checked: changePlanRequest.afterPlan === "both" || changePlanRequest.afterPlan === '',
      label: displayPlan("both"),
      onChange: () => setChangePlanRequest({...changePlanRequest, afterPlan: "both"})
    },
    {
      checked:  changePlanRequest.afterPlan === "right",
      label: displayPlan("right"),
      onChange: () => setChangePlanRequest({...changePlanRequest, afterPlan: "right"})
    },
    {
      checked: changePlanRequest.afterPlan === "left",
      label: displayPlan("left"),
      onChange: () => setChangePlanRequest({...changePlanRequest, afterPlan: "left"})
    },
  ];

  return (
    <React.Fragment>
      <div className="contact-box__item">
        <label className="contact-box__ttl">
          <span>{label}</span>
        </label>
        <div className="contact-box__ct">
          <p className="contact-box__desc mbpc-5 mbsp-5">{displayPlan(plan ?? '')}</p>
          {status !== 'before_confirmation' && 
            <label className="checkbox-item correct-box__form-check mb0">
              <input
                type="checkbox"
                checked={changePlanRequest.isChangePlan}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  if(e.target.checked) {
                    setChangePlanRequest({
                      changeMonth: "",
                      afterPlan: "both",
                      isChangePlan: true
                    })
                  } else {
                    setChangePlanRequest({
                      changeMonth: "",
                      afterPlan: "",
                      isChangePlan: false
                    })
                  }
                }}
                id="fruitCheckbox"
              />
              <span className="checkmark"></span>
              プラン変更
            </label>
          }
        </div>
      </div>
      {changePlanRequest.isChangePlan &&
        <>
          <RadioFieldBox
            label="変更プラン"
            list={planOptions}
          />
          <DateFieldBox
            type="month"
            label={"プラン変更月"}
            value={changePlanRequest.changeMonth}
            required={true}
            onChange={event => {
              setChangePlanRequest({...changePlanRequest, changeMonth: event.target.value})
            }}
          />
        </>
      }
    </React.Fragment>
  )
}